import React from 'react';
import PropTypes from 'prop-types';

import DateTimeTooltip from './DateTimeTooltip';

import {
  datePrefix,
  getDateTime,
  getFormattedDateTime,
} from '../helpers/DateTime';

const DateTime = ({
  id,
  className,
  dateTime,
  formatted,
  noTooltip,
}) => (
  <>
    <span id={id} className={className}>
      {datePrefix()}{formatted ? getFormattedDateTime(dateTime) : getDateTime(dateTime)}
    </span>
    {!noTooltip && (
      <DateTimeTooltip dateTime={dateTime} target={id} />
    )}
  </>
);

DateTime.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  dateTime: PropTypes.string.isRequired,
  formatted: PropTypes.bool,
  noTooltip: PropTypes.bool,
};

DateTime.defaultProps = {
  className: '',
  formatted: true,
  noTooltip: false,
};

export default DateTime;
